import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles, Check, X } from "lucide-react";

const PROJECT_CHAT_PERKS = [
  "Tasks",
  "Action Items",
  "Project Files",
  "Meeting Notes",
  "Project Memory",
  "Saved Research",
  "AI Project Context",
];

/**
 * Reusable upsell shown when a Free user taps a Pro-only capability
 * (Project Chat, tasks, etc). Copy per spec §8.
 */
export default function UpgradeModal({ open, onOpenChange, feature = "project_chat" }) {
  const nav = useNavigate();
  const perks = feature === "project_chat" ? PROJECT_CHAT_PERKS : [];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0a0a0a] border-white/10 rounded-sm max-w-md p-0 overflow-hidden" data-testid="upgrade-modal">
        <DialogHeader className="px-6 pt-6 pb-3 text-left">
          <div className="w-11 h-11 rounded-xl bg-brand/15 flex items-center justify-center mb-3">
            <Sparkles className="w-5 h-5 text-brand" />
          </div>
          <DialogTitle className="font-display tracking-tight text-[22px]">Project Chat</DialogTitle>
          <p className="text-[14px] text-zinc-400 mt-1.5">
            Turn conversations into organized projects.
          </p>
        </DialogHeader>
        <div className="px-6 pb-2">
          <div className="text-[11px] font-mono uppercase tracking-widest text-zinc-500 mb-2">Includes</div>
          <ul className="grid grid-cols-2 gap-1.5">
            {perks.map((p) => (
              <li key={p} className="flex items-center gap-2 text-[13px] text-zinc-200">
                <Check className="w-3.5 h-3.5 text-emerald-400 shrink-0" /> {p}
              </li>
            ))}
          </ul>
        </div>
        <div className="px-6 py-5 flex items-center gap-3">
          <Button
            data-testid="upgrade-modal-cta"
            onClick={() => {
              onOpenChange(false);
              nav("/billing");
            }}
            className="bg-brand text-black hover:bg-yellow-300 rounded-sm flex-1 h-11 font-semibold"
          >
            Upgrade to Pro
          </Button>
          <Button
            variant="ghost"
            data-testid="upgrade-modal-dismiss"
            onClick={() => onOpenChange(false)}
            className="rounded-sm h-11 text-zinc-400 hover:text-white"
          >
            <X className="w-4 h-4 mr-1" /> Not now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
